import ClientLogos, { LogoObject } from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import EventHeroSection from "@components/new-ui/EventHeroSection";
import EventRegistrationFormSection from "@components/new-ui/EventRegistrationFormSection";
import EventTabbedHighlightsSection, { EventTabbedHighlightsData } from "@components/new-ui/EventTabbedHighlightsSection";
import EventRegistrationSection, { EventRegistrationData } from "@components/new-ui/EventRegistrationSection";
import EventTimeline, { EventTimelineItem } from "@components/new-ui/EventTimeline";
import NewLayout from "@components/new-ui/Layout";
import TestimonialSection from "@components/new-ui/TestimonialSection";
import meta2026Data from "@data/event/meta-2026.json";
import React from "react";
import SpotlightSection from "@components/new-ui/SpotlightSection";

const GallaboxMeta: React.FC = () => {
    return (
        <NewLayout
            title="Gallabox for Meta | WhatsApp automation & Click-to-WhatsApp | Gallabox"
            description="Bridge Meta ads and WhatsApp Business with Gallabox. Run Click-to-WhatsApp campaigns, automate follow-ups, and convert social traffic without losing context."
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/meta-event-assets/gallabox-meta-event-og.png" }}
            showBanner={false}
        >
            <EventHeroSection />
            <EventRegistrationFormSection />
            <section className={`${container_classname} mt-10 mb-20`}>
                <h3 className="text-center text-lg font-normal py-5">TRUSTED BY 10,000+ BUSINESSES</h3>
                <ClientLogos logos={meta2026Data.clientLogos as LogoObject[]} />
            </section>
            <SpotlightSection
                data={meta2026Data.spotlight}
                headerText={
                    <p className="text-6xl font-semibold md:max-w-3xl" style={{ fontFamily: "Degular Display" }}>
                        Your customers are ready to buy when
                        <span className="text-primary font-bold" style={{ color: "rgba(51, 100, 255, 1)", fontStyle: "italic" }}>
                            {" "}
                            they{" "}
                        </span>
                        are
                    </p>
                }
            />
            <EventTabbedHighlightsSection data={meta2026Data.tabbedHighlights as EventTabbedHighlightsData} />
            <EventTimeline title={meta2026Data.agenda.title} subtitle={meta2026Data.agenda.subtitle} items={meta2026Data.agenda.items as EventTimelineItem[]} />
            <EventRegistrationSection data={meta2026Data.registration as EventRegistrationData} />
            <TestimonialSection />
            <CTASection title="Connections, conversations and conversions " description="Be among the first to ride the automation wave" />
        </NewLayout>
    );
};

export default GallaboxMeta;
